import {Component, Inject, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {NavigationComponentService} from '@app/services/navigation-component.service';
import {NgbDropdown} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'dcp-help-icon',
  templateUrl: './help-icon.component.html',
  styleUrls: ['./help-icon.component.scss']
})
export class HelpIconComponent implements OnInit {
  @ViewChild(NgbDropdown) dropdown: NgbDropdown;
  highlighted: boolean = false;
  helpIconLinks$: any;
  componentId: string = 'HelpIconMenuNavigation';

  constructor(
    @Inject(PLATFORM_ID) public platformId: object,
    public navigationComponentService: NavigationComponentService,
  ) {
  }

  ngOnInit() {
    this.helpIconLinks$ = this.navigationComponentService.fetchComponentData(this.componentId);
  }

  onChange(event: boolean): void {
    this.highlighted = event;
  }

  closeDropdown(): void {
    if (this.dropdown) {
      this.dropdown.close();
    }
  }

  openDropdown(): void {
    if (this.dropdown) {
      this.dropdown.open();
    }
  }
}
